var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "search-term" },
        [
          _c(
            "el-form",
            { attrs: { inline: true, model: _vm.searchInfo } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "用户名" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.userName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "userName", $$v)
                      },
                      expression: "searchInfo.userName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "选择油站" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "搜索条件"
                      },
                      model: {
                        value: _vm.searchInfo.sellerId,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "sellerId", $$v)
                        },
                        expression: "searchInfo.sellerId"
                      }
                    },
                    _vm._l(_vm.stationOptions, function(item) {
                      return _c("el-option", {
                        key: item.ID,
                        attrs: { label: item.stationName, value: item.ID }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "选择集团" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "搜索条件"
                      },
                      model: {
                        value: _vm.searchInfo.stationGroupNo,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "stationGroupNo", $$v)
                        },
                        expression: "searchInfo.stationGroupNo"
                      }
                    },
                    _vm._l(_vm.stationGroupOptions, function(item) {
                      return _c("el-option", {
                        key: item.stationGroupNo,
                        attrs: {
                          label: item.stationGroupName,
                          value: item.stationGroupNo
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "用户角色" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "搜索条件"
                      },
                      model: {
                        value: _vm.searchInfo.authorityId,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "authorityId", $$v)
                        },
                        expression: "searchInfo.authorityId"
                      }
                    },
                    _vm._l(_vm.authOptions, function(item) {
                      return _c("el-option", {
                        key: item.authorityId,
                        attrs: {
                          label: item.authorityName,
                          value: item.authorityId
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.addUser } },
                    [_vm._v("新增用户")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        { attrs: { data: _vm.tableData, border: "", stripe: "" } },
        [
          _c("el-table-column", {
            attrs: { label: "头像", "min-width": "50" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      { style: { textAlign: "center" } },
                      [
                        _c("CustomPic", {
                          attrs: { "pic-src": scope.row.headerImg }
                        })
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "uuid", "min-width": "250", prop: "uuid" }
          }),
          _c("el-table-column", {
            attrs: { label: "用户名", "min-width": "150", prop: "userName" }
          }),
          _c("el-table-column", {
            attrs: { label: "昵称", "min-width": "150", prop: "nickName" }
          }),
          _c("el-table-column", {
            attrs: { label: "所属油站", "min-width": "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-cascader", {
                      attrs: {
                        clearable: "",
                        options: _vm.stationOptions,
                        "show-all-levels": false,
                        props: {
                          checkStrictly: true,
                          label: "stationName",
                          value: "ID",
                          disabled: "disabled",
                          emitPath: false
                        },
                        filterable: ""
                      },
                      on: {
                        change: function($event) {
                          return _vm.changeStation(scope.row)
                        }
                      },
                      model: {
                        value: scope.row.sellerId,
                        callback: function($$v) {
                          _vm.$set(scope.row, "sellerId", $$v)
                        },
                        expression: "scope.row.sellerId"
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "所属集团", "min-width": "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-cascader", {
                      attrs: {
                        clearable: "",
                        options: _vm.stationGroupOptions,
                        "show-all-levels": false,
                        props: {
                          checkStrictly: true,
                          label: "stationGroupName",
                          value: "stationGroupNo",
                          disabled: "disabled",
                          emitPath: false
                        },
                        filterable: ""
                      },
                      on: {
                        change: function($event) {
                          return _vm.changeStation(scope.row)
                        }
                      },
                      model: {
                        value: scope.row.stationGroupNo,
                        callback: function($$v) {
                          _vm.$set(scope.row, "stationGroupNo", $$v)
                        },
                        expression: "scope.row.stationGroupNo"
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "用户角色", "min-width": "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-cascader", {
                      attrs: {
                        options: _vm.authOptions,
                        "show-all-levels": false,
                        props: {
                          checkStrictly: true,
                          label: "authorityName",
                          value: "authorityId",
                          disabled: "disabled",
                          emitPath: false
                        },
                        filterable: ""
                      },
                      on: {
                        change: function($event) {
                          return _vm.changeAuthority(scope.row)
                        }
                      },
                      model: {
                        value: scope.row.authority.authorityId,
                        callback: function($$v) {
                          _vm.$set(scope.row.authority, "authorityId", $$v)
                        },
                        expression: "scope.row.authority.authorityId"
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", "min-width": "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-popover",
                      {
                        attrs: { placement: "top", width: "160" },
                        model: {
                          value: scope.row.visible,
                          callback: function($$v) {
                            _vm.$set(scope.row, "visible", $$v)
                          },
                          expression: "scope.row.visible"
                        }
                      },
                      [
                        _c("p", [_vm._v("确定要删除此用户吗")]),
                        _c(
                          "div",
                          {
                            staticStyle: { "text-align": "right", margin: "0" }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "text" },
                                on: {
                                  click: function($event) {
                                    scope.row.visible = false
                                  }
                                }
                              },
                              [_vm._v("取消")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", size: "mini" },
                                on: {
                                  click: function($event) {
                                    return _vm.deleteUser(scope.row)
                                  }
                                }
                              },
                              [_vm._v("确定")]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              slot: "reference",
                              type: "danger",
                              icon: "el-icon-delete",
                              size: "small"
                            },
                            slot: "reference"
                          },
                          [_vm._v("删除")]
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 30, 50, 100],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.addUserDialog,
            "custom-class": "user-dialog",
            title: "新增用户"
          },
          on: {
            "update:visible": function($event) {
              _vm.addUserDialog = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "userForm",
              attrs: { rules: _vm.rules, model: _vm.userInfo }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "用户名",
                    "label-width": "80px",
                    prop: "username"
                  }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.userInfo.username,
                      callback: function($$v) {
                        _vm.$set(_vm.userInfo, "username", $$v)
                      },
                      expression: "userInfo.username"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "密码",
                    "label-width": "80px",
                    prop: "password"
                  }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.userInfo.password,
                      callback: function($$v) {
                        _vm.$set(_vm.userInfo, "password", $$v)
                      },
                      expression: "userInfo.password"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "别名",
                    "label-width": "80px",
                    prop: "nickName"
                  }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.userInfo.nickName,
                      callback: function($$v) {
                        _vm.$set(_vm.userInfo, "nickName", $$v)
                      },
                      expression: "userInfo.nickName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "头像", "label-width": "80px" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "inline-block" },
                      on: { click: _vm.openHeaderChange }
                    },
                    [
                      _vm.userInfo.headerImg
                        ? _c("img", {
                            staticClass: "header-img-box",
                            attrs: { src: _vm.userInfo.headerImg }
                          })
                        : _c("div", { staticClass: "header-img-box" }, [
                            _vm._v("从媒体库选择")
                          ])
                    ]
                  )
                ]
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "用户角色",
                    "label-width": "80px",
                    prop: "authorityId"
                  }
                },
                [
                  _c("el-cascader", {
                    attrs: {
                      options: _vm.authOptions,
                      "show-all-levels": false,
                      props: {
                        checkStrictly: true,
                        label: "authorityName",
                        value: "authorityId",
                        disabled: "disabled",
                        emitPath: false
                      },
                      filterable: ""
                    },
                    model: {
                      value: _vm.userInfo.authorityId,
                      callback: function($$v) {
                        _vm.$set(_vm.userInfo, "authorityId", $$v)
                      },
                      expression: "userInfo.authorityId"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { "label-width": "80px", label: "选择集团" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: "请选择",
                        clearable: ""
                      },
                      model: {
                        value: _vm.userInfo.stationGroupNo,
                        callback: function($$v) {
                          _vm.$set(_vm.userInfo, "stationGroupNo", $$v)
                        },
                        expression: "userInfo.stationGroupNo"
                      }
                    },
                    [
                      _c("el-option", {
                        key: 0,
                        attrs: { label: "无", value: 0 }
                      }),
                      _vm._l(_vm.stationGroupOptions, function(item) {
                        return _c("el-option", {
                          key: item.stationGroupNo,
                          attrs: {
                            label: item.stationGroupName,
                            value: item.stationGroupNo
                          }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { "label-width": "80px", label: "选择油站" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: "请选择",
                        clearable: ""
                      },
                      model: {
                        value: _vm.userInfo.sellerId,
                        callback: function($$v) {
                          _vm.$set(_vm.userInfo, "sellerId", $$v)
                        },
                        expression: "userInfo.sellerId"
                      }
                    },
                    [
                      _c("el-option", {
                        key: 0,
                        attrs: { label: "无", value: 0 }
                      }),
                      _vm._l(_vm.stationOptions, function(item) {
                        return _c("el-option", {
                          key: item.ID,
                          attrs: { label: item.stationName, value: item.ID }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeAddUserDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.enterAddUserDialog }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("ChooseImg", {
        ref: "chooseImg",
        attrs: { target: _vm.userInfo, "target-key": "headerImg" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }